(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/gameguide/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/gameguide/assets/javascripts/prescript.js');


(function(svs) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.gameguide = svs.components.gameguide || {};
  svs.components.gameguide.templates = svs.components.gameguide.templates || {};
})(svs);


 })(window);